module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center titletop"
  }, [_c('span', {
    staticClass: "textStyle1"
  }, [_vm._v("Plutarco Elías Calles and the Mexican Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "center top1"
  }, [_c('span', {
    staticClass: "textStyle2"
  }, [_vm._v("Jürgen Buchenau")])]), _vm._v(" "), _c('p', {
    staticClass: "center top2"
  }, [_c('span', {
    staticClass: "textStyle3"
  }, [_vm._v("ROWMAN & LITTLEFIELD PUBLISHERS, INC.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "textStyle4"
  }, [_vm._v("Lanham • Boulder • New York • Toronto • Plymouth, UK")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d043d97","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TitlePage.vue
// module id = 60
// module chunks = 0